import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import myLibraryActions from 'redux/actions/my_library_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import upgradeSourceTypes from 'helpers/enums/metrics/upgradeSourceTypes'

import PaywallStorageConfirm from 'views/my_library/confirms/my_library_paywall_storage'

class PaywallStorageConfirmContainer extends PureComponent {

	upgradeSelected = () => {
		this.props.actions.upgradeSelected(this.props.upgradeSource)
	}

	render() {
		return (
			<PaywallStorageConfirm
				alertMessage={this.props.message}
				closeConfirmSelected={this.props.actions.closeConfirmSelected}
				upgradeSelected={this.upgradeSelected}
			/>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		upgradeSelected: myLibraryActions.upgradeSelected,
		closeConfirmSelected: myLibraryActions.closeConfirmSelected,
	}, dispatch)
}

PaywallStorageConfirmContainer.propTypes = {
	message: PropTypes.string,
	actions: PropTypes.shape({
		upgradeSelected: PropTypes.func.isRequired,
		closeConfirmSelected: PropTypes.func.isRequired,
	}),
	upgradeSource: PropTypes.oneOf(
		Object.values(upgradeSourceTypes)
	).isRequired,
}

export default connect(null, mapDispatchToProps)(
	PaywallStorageConfirmContainer
)

export { PaywallStorageConfirmContainer }
